// src/styles/designSystem.js
export const colors = {
    primary: {
      gradient: 'bg-gradient-to-r from-violet-600 to-indigo-600',
      text: 'bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent',
      light: 'from-violet-500/10 to-indigo-500/10',
    },
    success: {
      gradient: 'bg-gradient-to-r from-emerald-500 to-teal-500',
      text: 'bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent',
    },
    container: {
      base: 'bg-white rounded-2xl shadow-xl border border-gray-100',
      hover: 'hover:shadow-lg transition-all duration-300',
    },
    text: {
      heading: 'text-3xl font-bold',
      body: 'text-gray-600',
      subtitle: 'text-gray-500',
    }
  };